/**
 * Central routes configuration for Erazer XP2
 * This file defines all navigation items for consistent use across the application
 */

// Main navigation routes (internal pages)
export const mainRoutes = [
  {path: '/how-it-works', label: 'How It Works', translate: false},
  {path: '/pricing', label: 'Pricing', translate: false},
  {path: '/contact', label: 'Contact', translate: true}
];

// Footer-specific additional links
export const footerRoutes = [
  {path: '/how-it-works', label: 'How It Works', translate: false},
  {path: '/pricing', label: 'Pricing', translate: false},
  {path: '/contact', label: 'Contact', translate: true}
];

// External links configuration
export const externalRoutes = [
  // Removed GitHub and Codeberg links as requested
];
